import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

export default class FrontpageHero {
	constructor() {
		const hero = document.querySelector('.site--hero');
		if (!hero) {
			return;
		}
		const hero_heading = hero.querySelector('.site--hero__heading h1');
		const hero_text = hero.querySelector('.site--hero__content p');
		const project_hero_links = hero.querySelectorAll('.wp-block-button');
		const project_hero_specs = hero.querySelectorAll('.site--project__specification');

		var tl = gsap.timeline({});

		var text = new SplitText(hero_heading, { type: 'words,chars' });
		var chars = text.chars;

		gsap.set(hero_heading, { perspective: 400 });

		if (chars) {
			tl.from(chars, {
				duration: 1,
				ease: 'circ.out',
				y: 50,
				// stagger: 0.01,
				opacity: 0,
				// scale: 0,
				delay: 0.2,
			});
		}
		if (hero_text) {
			tl.from(
				hero_text,
				{
					duration: 1,
					ease: 'circ.out',
					y: 50,
					opacity: 0,
				},
				'.35'
			);
		}
		if (project_hero_specs) {
			tl.from(
				project_hero_specs,
				{
					stagger: 0.15,
					duration: 1,
					ease: 'circ.out',
					y: 50,
					opacity: 0,
				},
				'.25'
			);
		}
		if (project_hero_links) {
			tl.from(
				project_hero_links,
				{
					stagger: 0.15,
					duration: 1,
					ease: 'circ.out',
					y: 50,
					opacity: 0,
				},
				'.5'
			);
		}
	}
}
